const escapeHtml = (value) => String(value ?? '')
	.replace(/&/g, '&amp;')
	.replace(/</g, '&lt;')
	.replace(/>/g, '&gt;')
	.replace(/"/g, '&quot;')
	.replace(/'/g, '&#039;');

const formatDate = (value) => {
	if (!value) return '';

	const date = new Date(String(value).replace(' ', 'T'));
	if (Number.isNaN(date.getTime())) return '';

	return new Intl.DateTimeFormat('fr-CA', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	}).format(date);
};

const renderJob = (job) => {
	const types = Array.isArray(job.positionType) ? job.positionType : [];
	const typesMarkup = types.map((type) => `<li class="rja-type">${escapeHtml(type.title)}</li>`).join('');
	const readableDate = job.published_at_readable || formatDate(job.published_at);
	const dateMarkup = readableDate ? `<li class="rja-date">Publi&eacute; ${escapeHtml(readableDate)}</li>` : '';
	const companyMarkup = job.companyName ? `<div class="rja-company">${escapeHtml(job.companyName)}</div>` : '';
	const locationMarkup = job.location ? `<div class="rja-location">${escapeHtml(job.location)}</div>` : '';
	const jobHref = job.url;
	const typesListMarkup = typesMarkup ? `<ul class="rja-types" aria-label="Types de poste">${typesMarkup}</ul>` : '';
	const content = `
		<div class="rja-logo" aria-hidden="true">
			<img src="/assets/images/company.png" alt="">
		</div>
		<div class="rja-position">
			<h3 class="rja-title">${escapeHtml(job.title)}</h3>
			${typesListMarkup}
		</div>
		${locationMarkup}
		${companyMarkup}
		<ul class="rja-meta" aria-label="Details de l'offre">
			${dateMarkup}
		</ul>
	`;

	if (jobHref) {
		return `<article class="row-job-announce"><a class="rja-link" href="${escapeHtml(jobHref)}" aria-label="${escapeHtml(job.title)}">${content}</a></article>`;
	}

	return `<article class="row-job-announce"><div class="rja-link">${content}</div></article>`;
};

const initJobOffersList = (module) => {
	const form = module.querySelector('[data-job-offers-filters]');
	const results = module.querySelector('[data-job-offers-results]');
	const moreButton = module.querySelector('[data-job-offers-more]');
	const resetButton = module.querySelector('[data-job-offers-reset]');
	const status = module.querySelector('[data-job-offers-status]');
	const apiUrl = module.dataset.apiUrl;
	const limit = Number.parseInt(module.dataset.limit || '20', 10);
	let offset = 0;
	let isLoading = false;

	if (!form || !results || !moreButton || !apiUrl) return;

	const getParams = (nextOffset) => {
		const params = new URLSearchParams();
		params.set('limit', String(limit));
		params.set('offset', String(nextOffset));

		const category = form.querySelector('[name="categories"]')?.value;
		if (category) params.append('categories[]', category);

		const keyword = form.querySelector('[name="q"]')?.value.trim();
		if (keyword) params.set('q', keyword);

		const location = form.querySelector('[name="location"]')?.value.trim();
		if (location) params.set('location', location);

		form.querySelectorAll('[name="positionsType"]:checked').forEach((input) => {
			params.append('positionsType[]', input.value);
		});

		if (form.querySelector('[name="isRemote"]')?.checked) {
			params.set('isRemote', '1');
		}

		return params;
	};

	const setLoading = (loading) => {
		isLoading = loading;
		module.classList.toggle('is-loading', loading);
		moreButton.disabled = loading;
		if (resetButton) resetButton.disabled = loading;
		if (status && loading) status.textContent = 'Chargement des offres...';
	};

	const load = async ({ reset = false } = {}) => {
		if (isLoading) return;

		const nextOffset = reset ? 0 : offset;
		setLoading(true);

		try {
			const response = await fetch(`${apiUrl}?${getParams(nextOffset).toString()}`, {
				headers: { Accept: 'application/json' },
			});

			if (!response.ok) throw new Error(`HTTP ${response.status}`);

			const data = await response.json();
			const jobs = Array.isArray(data.offers) ? data.offers : [];

			if (reset) {
				results.innerHTML = '';
				offset = 0;
			}

			if (jobs.length) {
				results.insertAdjacentHTML('beforeend', jobs.map((job) => renderJob(job)).join(''));
			} else if (reset) {
				results.innerHTML = '<p class="joboffers-empty">Aucune offre trouvée.</p>';
			}

			offset = nextOffset + jobs.length;
			moreButton.hidden = !data.hasMore;
			if (status) status.textContent = '';
		} catch (error) {
			if (status) status.textContent = 'Impossible de charger les offres pour le moment.';
		} finally {
			setLoading(false);
		}
	};

	let inputTimeout;
	const scheduleInputLoad = () => {
		clearTimeout(inputTimeout);
		inputTimeout = setTimeout(() => load({ reset: true }), 300);
	};

	form.addEventListener('change', () => load({ reset: true }));
	form.querySelectorAll('[name="q"], [name="location"]').forEach((input) => {
		input.addEventListener('input', scheduleInputLoad);
	});
	form.addEventListener('submit', (event) => {
		event.preventDefault();
		load({ reset: true });
	});
	form.addEventListener('reset', () => {
		window.setTimeout(() => {
			form.querySelectorAll('.frm-select2').forEach((select) => {
				if (window.jQuery && window.jQuery(select).data('select2')) {
					window.jQuery(select).trigger('change.select2');
				}
			});

			load({ reset: true });
		}, 0);
	});

	moreButton.addEventListener('click', () => load());
	offset = results.querySelectorAll('.row-job-announce').length;
};

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-job-offers-list]').forEach(initJobOffersList);
});
